import { PAGES } from "../../../config/constants";

const project = {
  type: 'site',
  dlink: false,
  dlinkownerisme: false,
  defaultPage: PAGES.FILE_MANAGER,
  documentCanRenderExt: ['pdf', 'txt', 'html', 'htm'],
  excludeAudioExt: ['m3u', 'pls'],
  ourTopLevelDomains: ['pcloud.com', 'pcloud.link'],
  isSite: function () {
    return this.type == 'site';
  },
  isMobile: function () {
    return this.type == 'mobile';
  },
  isDlink: function () {
    return this.dlink;
  },
  isDlinkOwner: function () {
    return this.dlinkownerisme;
  },
  isWebview: function () {
    return this.type == 'webview';
  },
  isPublinkMobile: function() {
    return this.isDlink() && this.isMobile();
  },
  isRtl: function () {
    return pCloudIntl.getLangObj().rtl;
  },
  isBackup: function (data) {
    if (!data) {
      return;
    }

    return data.isbackupdevicelist || data.isbackupdevice || data.isbackuproot || data.isbackup || data.backupdesktop;
  },
  isRestrictedMobileBackup: function(data) {
    if (!data) {
      return;
    }

    return data.virtualfolder && data.folderid === 0 && !data.ecnrypted;

  },
  isRestrictedDesktopBackup: function(data) {
    if (!data) {
      return;
    }

    return (data.virtualfolder && data.backupdesktop) || data.isbackupdevicelist || data.isbackupdevice;
  },
  showTempCryptoPassMessage: true,
  languages: { en: 'English' },
  label: {
    hasNotificationSettings: true,
    canSelfDeleteAccounts: true,
    hasLinkedAccounts: true,
    hasAccountLangs: true,
    hasSocialBackup: true,
    hasFAQtabs: false,
    hasPlans: true,
    hasTerms: function() {
      var translatedLangs = ["fr", "de", "ja"];
      var lang = translatedLangs.indexOf(pCloudIntl.getLang()) !== -1 ? "-" + pCloudIntl.getLang() : "";
      return '/json/article' + lang +'.json';
    },
    hasCrypto: true,
    siteName: 'pCloud',
    domain: 'pcloud.com',
    siteLink: 'https://www.pcloud.com',
    hasUpgradeInHeader: true,
    hasLiveChat: true,
    hasTradeSite: true,
    hasInviteToFolder: true,
    hasInvoices: true,
    has2FA: true,
    isUsernameEmail: true,
    assets: [],
    switchAssets: [],
    init: function() {},
    hasFullTextSearch: true,
    mobile: {
    }
  }
};

export default project;